module.exports = __webpack_public_path__ + "static/media/ico_btn_titre.838487f8.svg";